<style lang="scss">
* {
    margin: 0;
}

.login-content-div {
    margin: 0 !important;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    position: relative;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        width: 200%;
        height: 200%;
        background: url('/public/img/2354675581558.jpg') center/cover;
        opacity: 0.08;
        animation: rotate 30s linear infinite;
    }

    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: radial-gradient(circle at center, transparent 0%, rgba(0, 0, 0, 0.4) 100%);
    }

    @media screen and (max-width: 600px) {
        padding: 1rem;
    }
}

.content-div-out {
    position: relative;
    z-index: 1;
    display: flex;
    overflow: hidden;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
    border-radius: 1.5rem;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    backdrop-filter: blur(10px);

    &:hover {
        transform: none;
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
    }

    @media screen and (max-width: 600px) {
        width: 90vw !important;
        height: auto !important;
        margin: 0 !important;
        flex-direction: column;
    }

    @media screen and (min-width: 601px) {
        width: 60rem !important;
        height: 33rem !important;
        margin: 0 auto !important;
    }
}

.content-div-left {
    background: linear-gradient(135deg, #6B46C1 0%, #805AD5 100%);
    position: relative;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: -50%;
        left: -50%;
        width: 200%;
        height: 200%;
        background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 60%);
        animation: rotate 20s linear infinite;
    }

    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23ffffff' fill-opacity='0.05' fill-rule='evenodd'/%3E%3C/svg%3E");
    }

    @media screen and (max-width: 600px) {
        height: 35vh;
        width: 100% !important;
        border-top-left-radius: 1.5rem;
        border-top-right-radius: 1.5rem;
    }

    @media screen and (min-width: 601px) {
        height: 33rem;
        width: 50%;
        border-top-left-radius: 1.5rem;
        border-bottom-left-radius: 1.5rem;
    }
}

.content-div-right {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    position: relative;
    border: 1px solid rgba(255, 255, 255, 0.2);

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%);
    }

    @media screen and (max-width: 600px) {
        height: auto;
        width: 100% !important;
        padding: 2rem 0;
        border-bottom-right-radius: 1.5rem;
        border-bottom-left-radius: 1.5rem;
    }

    @media screen and (min-width: 601px) {
        height: 33rem;
        width: 50%;
        border-bottom-right-radius: 1.5rem;
        border-top-right-radius: 1.5rem;
    }
}

.content-left-text {
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    padding: 2rem;
    position: relative;
    z-index: 1;

    .welcome-text {
        font-size: 2.5rem;
        font-weight: bold;
        margin-bottom: 1rem;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        background: linear-gradient(to right, #fff, #e2e8f0);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        letter-spacing: 0.05em;
    }

    span:last-child {
        font-size: 1.2rem;
        opacity: 0.9;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
        letter-spacing: 0.03em;
    }
}

.content-right-login {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    padding: 2rem;
}

.form-el-data {
    width: 100%;
    max-width: 25rem;
    margin: 0 auto;

    :deep(.el-form-item__label) {
        font-weight: 500;
        color: #4a5568;
        font-size: 0.95rem;
        letter-spacing: 0.02em;
        margin-bottom: 0.5rem;
    }

    :deep(.el-input__wrapper) {
        background: rgba(255, 255, 255, 0.9);
        box-shadow: none;
        border: 2px solid rgba(107, 70, 193, 0.1);
        transition: all 0.3s ease;
        border-radius: 0.75rem;
        padding: 0.25rem 1rem;
        height: 3rem;

        &:hover {
            border-color: rgba(107, 70, 193, 0.3);
            background: white;
        }

        &:focus-within {
            border-color: #6B46C1;
            background: white;
            box-shadow: 0 0 0 4px rgba(107, 70, 193, 0.1);
        }

        &.is-focus {
            box-shadow: none;
        }
    }

    :deep(.el-input__inner) {
        height: 2.5rem;
        font-size: 0.95rem;
        letter-spacing: 0.02em;
        color: #2d3748;

        &::placeholder {
            color: #a0aec0;
        }
    }

    :deep(.el-input__prefix),
    :deep(.el-input__suffix) {
        color: #a0aec0;
    }
}

.form-el-btn {
    margin: 2.5rem auto;
    width: 100%;
    max-width: 25rem;

    .el-button {
        width: 100%;
        height: 3rem;
        font-size: 1rem;
        font-weight: 500;
        transition: all 0.3s ease;
        background: linear-gradient(135deg, #6B46C1 0%, #805AD5 100%);
        border: none;
        border-radius: 0.75rem;
        letter-spacing: 0.02em;
        box-shadow: 0 4px 6px rgba(107, 70, 193, 0.2);

        &:hover {
            transform: none;
            box-shadow: 0 6px 8px rgba(107, 70, 193, 0.3);
            background: linear-gradient(135deg, #805AD5 0%, #6B46C1 100%);
        }

        &:active {
            transform: none;
            box-shadow: 0 2px 4px rgba(107, 70, 193, 0.2);
        }
    }
}

.input-emailCode,
.input-kaptchaCode {
    :deep(.el-input__wrapper) {
        background: rgba(255, 255, 255, 0.9);
        border: 2px solid rgba(107, 70, 193, 0.1);
        box-shadow: none;
        transition: all 0.3s ease;
        border-radius: 0.75rem;
        padding: 0.25rem 1rem;
        height: 3rem;

        &:hover {
            border-color: rgba(107, 70, 193, 0.3);
            background: white;
        }

        &:focus-within {
            border-color: #6B46C1;
            background: white;
            box-shadow: 0 0 0 4px rgba(107, 70, 193, 0.1);
        }
    }
}

.send_emailCode {
    height: 3rem;
    border-radius: 0.75rem;
    font-weight: 500;
    letter-spacing: 0.02em;
    background: linear-gradient(135deg, #6B46C1 0%, #805AD5 100%);
    border: none;
    box-shadow: 0 4px 6px rgba(107, 70, 193, 0.2);
    transition: all 0.3s ease;

    &:hover {
        box-shadow: 0 6px 8px rgba(107, 70, 193, 0.3);
        background: linear-gradient(135deg, #805AD5 0%, #6B46C1 100%);
    }

    &:active {
        box-shadow: 0 2px 4px rgba(107, 70, 193, 0.2);
    }
}

.kaptchaImg {
    height: 3rem;
    border-radius: 0.75rem;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 2px solid rgba(107, 70, 193, 0.1);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

    &:hover {
        opacity: 0.9;
        transform: none;
        border-color: rgba(107, 70, 193, 0.3);
    }
}

.bottom-div {
    position: absolute;
    bottom: 1rem;
    left: 0;
    right: 0;
    text-align: center;
    text-decoration: underline;
    color: #0d6efd;

    a {
        color: #6B46C1;
        text-decoration: none;
        font-size: 0.9rem;
        transition: all 0.3s ease;
        cursor: pointer;
        padding: 0.5rem 1rem;
        border-radius: 0.5rem;
        letter-spacing: 0.02em;

        &:hover {
            color: #805AD5;
            background: rgba(107, 70, 193, 0.1);
            text-decoration: none;
        }
    }
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

@media screen and (max-width: 700px) {
    .form-el-data {
        width: 100%;
        max-width: none;
    }

    .btn-list {
        margin-top: 1rem !important;
    }

    .input-emailCode {
        width: 6rem !important;
    }

    .send_emailCode {
        margin-left: 1rem;
    }

    .input-kaptchaCode {
        width: 4rem !important;
    }

    .kaptchaImg {
        margin-left: 1rem !important;
        width: 50%;
    }
}

@media screen and (min-width: 701px) {
    .send_emailCode {
        margin-left: 1rem;
    }

    .input-emailCode,
    .input-kaptchaCode {
        width: 10rem !important;
    }
}
</style>

<template>
    <div class="login-content-div">
        <div class="content-div-out shadow row">
            <div class="content-div-left col-md-6">
                <div class="content-left-text">
                    <span class="welcome-text">欢迎登录</span>
                    <span>易售SUP软件授权系统</span>
                </div>
            </div>
            <div class="content-div-right col-md-6">
                <div class="content-right-login">
                    <div class="form-div">
                        <el-form label-position="top" label-width="auto" ref="loginForm" class="form-el-data"
                            :model="login" :rules="rules">
                            <el-form-item label="账号" prop="email">
                                <el-input placeholder="默认为您的邮箱" v-model="login.email" />
                            </el-form-item>
                            <el-form-item label="验证码" prop="code" v-if="login_act == 1">
                                <el-input type="text" placeholder="邮箱验证码" v-model="login.code"
                                    class="input-emailCode" />
                                <el-button @click="getcodeClick()" class="send_emailCode" type="primary">{{
                                    login.getcode.text }}</el-button>
                            </el-form-item>
                            <el-form-item label="密码" prop="password" v-else>
                                <el-input type="password" placeholder="您的密码" v-model="login.password" />
                            </el-form-item>
                            <el-form-item label="验证码" prop="code" v-if="login_act == 2">
                                <el-input type="text" placeholder="验证码" v-model="login.code"
                                    class="input-kaptchaCode" />
                                <img class="kaptchaImg" ref="kaptchaImg" src="" @click="getKaptcha()">
                                <!-- <img v-show="login.email==''" style="width: 0;height: 0;" ref="kaptchaImg2" src="" /> -->
                                <!-- <el-button @click="getKaptcha()" type="primary" v-if="kaptchaImgSrc==''">
                                    获取验证码
                                </el-button> -->
                            </el-form-item>
                        </el-form>
                        <el-form-item class="form-el-btn btn-list">
                            <el-button type="primary" v-if="login_act == 1" @click="submitForm('loginForm')"
                                class="codeLogin-btn">
                                账号验证码登录
                            </el-button>
                            <el-button type="primary" v-else @click="submitForm('loginForm')">
                                账号密码登录
                            </el-button>
                            <!-- <el-button v-loading.fullscreen.lock="fullscreenLoading" type="primary"
                                @click="openFullScreen1">
                            </el-button> -->
                        </el-form-item>

                    </div>
                    <div class="bottom-div">
                        <a @click="bottom_btnClick('pass')" v-if="login_act == 1">邮箱+密码登录</a>
                        <a @click="bottom_btnClick('code')" v-if="login_act == 2">邮箱+验证码登录</a>
                    </div>
                </div>
            </div>

            <div></div>
        </div>
    </div>
</template>

<script>
import { defineComponent, ref, onMounted, watch } from 'vue'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
import { ElMessage } from 'element-plus';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    setup() {
        var login = ref({
            email: "",
            password: "",
            code: "",
            getcode: {
                text: "发送"
            },
        });
        var kaptchaImgToken = ref('')
        var login_act = ref(1)
        const bottom_btnClick = (act) => {
            if (act === "pass") {
                login_act.value = 2
            }
            else {
                login_act.value = 1
            }
        }
        const checkNumber = (rule, value, callback) => {
            if (!value || !isNaN(Number(value))) {
                callback();
            } else {
                callback(new Error('请输入数字验证码'));
            }
        }
        const rules = ({
            email: [
                { required: true, message: '请输入邮箱', trigger: ['change'] },
                { type: 'email', message: '请输入正确的邮箱格式', trigger: ['change'] },
            ],
            code: [
                { required: true, message: '请输入验证码' },
                { min: 1, max: 6, message: '验证码长度错误', trigger: ['blur', 'change'] },
            ],
            password: [
                { required: true, message: '请输入密码', trigger: ['change'] },
                { min: 6, max: 20, message: '长度在6-20位', trigger: ['change'] },
            ],
        })

        const loginForm = ref(null);

        // let fullscreenLoading
        // const openLoading = () => {
        //     fullscreenLoading = ElLoading.service({
        //         lock: true,
        //         text: 'Loading',
        //         background: 'rgba(0, 0, 0, 0.7)',
        //     })
        // }
        const debounce = (func, delay) => {
            let timeoutId;
            return (...args) => {
                clearTimeout(timeoutId);
                timeoutId = setTimeout(() => {
                    func(...args);
                }, delay);
            };
        };
        const submitForm = debounce((value) => {
            loginForm.value.validate((valid) => {
                if (valid) {
                    openLoading()
                    const data = new FormData()
                    data.append("email", login.value.email)
                    if (login_act.value == 1) {
                        data.append("act", "login_code")
                        data.append("code", login.value.code)
                    }
                    else {
                        data.append("act", "login_pass")
                        data.append("password", login.value.password)
                        data.append("code", login.value.code)
                        data.append("kaptchaImgToken", kaptchaImgToken.value)
                    }
                    axios.post(baseURL + "/userApi/login", data, { timeout: 30000 })
                        .then(res => {
                            fullscreenLoading.close()
                            if (res.data.code == 200) {
                                localStorage.setItem("token", res.data.token)
                                ElMessage.success(res.data.msg)
                                location.href = "/console"
                            }
                            else {
                                ElMessage.error(res.data.msg)
                                if (login_act.value != 1) {
                                    getKaptcha()
                                }
                            }
                        })
                        .catch(err => {
                            fullscreenLoading.close()
                            console.log(err)
                            ElMessage.error('请求失败' + err.message)
                        })
                }
                else {
                    ElMessage.error('请按照格式填写完整')
                }
            })
        }, 1000);
        const getcodeClick = () => {
            loginForm.value.validateField('email', (valid) => {
                if (valid) {
                    if (typeof login.value.getcode.text !== "string") {
                        ElMessage.error("请" + login.value.getcode.text + "秒后再试")
                        return
                    }
                    openLoading()
                    const data = new FormData()
                    data.append("email", login.value.email)
                    data.append("password", login.value.password)
                    data.append("act", "getcode")
                    axios.post(baseURL + "/userApi/login", data, { timeout: 10000 })
                        .then(res => {
                            fullscreenLoading.close()
                            if (res.data.code == 200) {
                                login.value.getcode.text = 60;
                                let code_text_inter = setInterval(() => {
                                    var code_text = login.value.getcode.text;
                                    if (code_text !== 0) {
                                        login.value.getcode.text--;
                                    }
                                    else if (code_text === 0) {
                                        login.value.getcode.text = "发送";
                                        clearInterval(code_text_inter)
                                    }
                                }, 1000);
                                ElMessage.success(res.data.msg)
                            }
                            else {
                                ElMessage.error(res.data.msg)
                            }
                        })
                        .catch(err => {
                            fullscreenLoading.close()
                            console.log(err)
                            ElMessage.error('请求失败' + err.message)
                        })
                }
                else {
                    ElMessage.error('请按照格式填写完整邮箱')
                }
            })
        }
        const isLogin = () => {
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.get(baseURL + "/userApi/isLogin", { timeout: 30000, headers: headers })
                .then(res => {
                    if (res.data.code == 200) {
                        ElMessage.success("您已经登录")
                        setTimeout(() => {
                            location.href = "/console"
                        }, 1000);
                    }
                })
                .catch(err => {
                    console.log(err)
                    ElMessage.error('请求失败：' + err.message)
                })
        }
        const kaptchaImg = ref(null)
        const getKaptcha = () => {
            axios.get(baseURL + "/userApi/getKaptcha")
                .then((res) => {
                    kaptchaImg.value.src = res.data.data
                    kaptchaImgToken.value = res.data.kaptchaImgToken
                })
        }
        watch(login_act, (newVal) => {
            if (newVal != 1) {
                getKaptcha()
            }
        })
        onMounted(isLogin)
        // 返回需要暴露给模板的数据
        return {
            login,
            login_act,
            rules,
            loginForm,
            kaptchaImg,
            kaptchaImgToken,
            bottom_btnClick,
            submitForm,
            getcodeClick,
            checkNumber,
            getKaptcha
        };
    },

})
</script>
